import l from '../../../../lang';
import Message from '../../../common/message';
import { MessageTypes } from '../../../../constants';
import ButtonLink from '../../../common/button-link';
import { useDashboard } from '../../../../store/dashboard';
import '../styles.scss';

const getTranslationKeys = (
  fraudReviewStatus?: string,
  fraudReviewType?: string
): { headline: string; subheadline: string; link?: string } | null => {
  if (fraudReviewType === 'KYC1_REJECTED') {
    return {
      headline: 'common.fraudReview.kyc1Rejected.headline',
      subheadline: 'common.fraudReview.kyc1Rejected.subheadline',
    };
  }

  if (fraudReviewType === 'KYC2_REJECTED') {
    return {
      headline: 'common.fraudReview.kyc2Rejected.headline',
      subheadline: 'common.fraudReview.kyc2Rejected.subheadline',
    };
  }

  switch (fraudReviewStatus) {
    case 'PREVENTIVE':
      return {
        headline: 'common.fraudReview.preventive.headline',
        subheadline: 'common.fraudReview.preventive.subheadline',
        link: 'common.fraudReview.preventive.subheadline.link',
      };
    case 'PERMANENT':
      return {
        headline: 'common.fraudReview.permanent.headline',
        subheadline: 'common.fraudReview.permanent.subheadline',
        link: 'common.fraudReview.permanent.subheadline.link',
      };
    case 'REMOVED':
      // REMOVED means the block was lifted, so it should not show any message
      // This case should not reach here because fraudReview would be false
      return null;
    default:
      return {
        headline: 'common.fraudReview.headline',
        subheadline: 'common.fraudReview.subheadline',
        link: 'common.fraudReview.subheadline.link',
      };
  }
};

const FraudMessage = () => {
  const { merchantMe } = useDashboard();
  const { canOperate, fraudReview, fraudReviewStatus, fraudReviewType } = merchantMe || {};

  if (canOperate || !fraudReview) {
    return null;
  }
  const keys = getTranslationKeys(fraudReviewStatus, fraudReviewType);
  // If keys is null (e.g., REMOVED status), don't show any message
  if (!keys) {
    return null;
  }

  return (
    <div className="alert_message">
      <Message
        type={MessageTypes.WARNING}
        title={l(keys.headline)}
        body={
          <span>
            <span>{l(keys.subheadline)} </span>
            <ButtonLink text={l(keys.link)} onClick={() => window.Intercom('show')} />
          </span>
        }
      />
    </div>
  );
};

export default FraudMessage;
